import React, { memo, useCallback } from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import { Tier } from 'features/premium/entities';
import createStyleSheets from 'utils/createStyleSheets';
import { selectUserTier } from 'features/premium/selectors/tier';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { selectTryFor0Text } from 'features/premium/selectors';
import Text from './Text';
import { rem } from './values';
const CardUpgradeRow = ({ title, withHorizontalMargins, }) => {
    const styles = useStyles(styleSet);
    const { navigateDeprecated } = useMainStackNavigation();
    const userTier = useAppSelector(selectUserTier);
    const handleUpgradePress = useCallback(() => {
        navigateDeprecated('EmmaProModal', {
            tier: userTier === Tier.pro ? Tier.ultimate : Tier.pro,
        });
    }, [userTier]);
    const tryFor0Text = useAppSelector(selectTryFor0Text);
    return (<TouchableBounce onPress={handleUpgradePress}>
      <View style={[
            styles.container,
            withHorizontalMargins && styles.horizontalMargins,
        ]}>
        <Text flex TextThin-14 OnBrand>
          {title}
        </Text>
        <Text Text-14 OnBrand>
          {tryFor0Text ?? 'Upgrade'}
        </Text>
      </View>
    </TouchableBounce>);
};
export const cardUpgradeRowHeight = rem(37);
export default memo(CardUpgradeRow);
const styleSet = createStyleSheets((colors) => ({
    container: {
        alignItems: 'center',
        borderRadius: rem(8),
        flexDirection: 'row',
        paddingHorizontal: rem(16),
        height: cardUpgradeRowHeight,
        backgroundColor: colors.buttons.brandGroup,
    },
    horizontalMargins: {
        marginHorizontal: rem(16),
    },
}));
